import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoalibaugcabs() {



    const cardData = {




keyword: "Mumbai to Alibaug Cab",

headingDescription: "Shreesha Tours & Travels offers reliable, comfortable, and affordable Mumbai to Alibaug cab services for families, couples, corporate travelers, tourists, and weekend vacationers. We provide one-way cabs, round-trip taxi services, same-day return trips, airport transfers, and customized outstation tour packages with experienced chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles suitable for solo travelers, families, and large groups. With doorstep pickup anywhere in Mumbai, flexible travel schedules, transparent pricing, instant booking assistance, and 24/7 customer support, Shreesha Tours & Travels ensures a smooth, safe, and enjoyable road trip. Whether you are planning a relaxing beach holiday, romantic getaway, corporate outing, family vacation, sightseeing tour, or weekend escape, our Mumbai to Alibaug cab service provides professional drivers, clean vehicles, and a comfortable travel experience, allowing you to explore the beautiful beaches, forts, temples, and coastal attractions of Alibaug at your own pace.",

topPlaces: [
  {
    title: "Alibaug Beach",
    description: "Alibaug Beach is the most famous attraction in the region, offering spectacular views of the Arabian Sea, soft sandy shores, horse cart rides, beach activities, and beautiful sunsets. It is an ideal destination for families, couples, and weekend travelers looking to relax by the sea."
  },
  {
    title: "Kolaba Fort",
    description: "Kolaba Fort is a historic sea fort built by Chhatrapati Shivaji Maharaj and is one of Alibaug's most visited landmarks. Accessible on foot during low tide or by boat during high tide, the fort offers magnificent sea views, ancient architecture, and a glimpse into Maratha history."
  },
  {
    title: "Varsoli Beach",
    description: "Varsoli Beach is known for its peaceful atmosphere, clean shoreline, coconut trees, and less crowded surroundings. It is a perfect destination for visitors looking to enjoy a quiet beach experience, photography, morning walks, and family outings."
  },
  {
    title: "Nagaon Beach",
    description: "Nagaon Beach is one of the most popular beaches near Alibaug, famous for water sports, banana boat rides, jet skiing, parasailing, and beachside resorts. Adventure enthusiasts and families frequently visit this destination for a fun-filled holiday."
  },
  {
    title: "Kihim Beach",
    description: "Kihim Beach is admired for its natural beauty, lush greenery, birdlife, and peaceful coastal environment. The beach is ideal for nature lovers, photographers, and travelers seeking a relaxing escape from city life."
  },
  {
    title: "Kanakeshwar Temple",
    description: "Kanakeshwar Temple is an ancient hilltop temple dedicated to Lord Shiva. Surrounded by dense greenery, the temple offers a spiritual atmosphere along with panoramic views of the Arabian Sea and nearby villages after a scenic climb."
  },
  {
    title: "Murud-Janjira Fort",
    description: "Murud-Janjira Fort is one of India's strongest island forts, renowned for its remarkable architecture, historical significance, and stunning location in the Arabian Sea. It is a must-visit attraction for history enthusiasts and tourists exploring the Konkan coastline."
  },
  {
    title: "Kashid Beach",
    description: "Kashid Beach is famous for its white sandy shoreline, crystal-clear waters, water sports, and peaceful surroundings. It is one of the finest beaches in the Konkan region and a favorite destination for couples, families, and beach lovers."
  },
  {
    title: "Revdanda Fort",
    description: "Revdanda Fort is a centuries-old Portuguese fort featuring ancient ruins, massive stone walls, and breathtaking coastal views. The fort is popular among history lovers and photographers interested in exploring Maharashtra's coastal heritage."
  },
  {
    title: "Phansad Wildlife Sanctuary",
    description: "Phansad Wildlife Sanctuary is a protected forest area near Alibaug known for its rich biodiversity, bird species, butterflies, trekking trails, and natural beauty. It is an excellent destination for wildlife enthusiasts, nature lovers, and eco-tourism travelers."
  }
],



"services": [
  {
    "name": "Mumbai to Alibaug Cab",
    "description": "Book Mumbai to Alibaug Cab for safe, comfortable, and reliable beach travel with professional chauffeurs and well-maintained AC vehicles. Choose Sedan, Ertiga, Innova Crysta, SUV, Tempo Traveller, and luxury cabs for one way, round trip, family vacations, and weekend getaways."
  },
  {
    "name": "Alibag to Mumbai Cab",
    "description": "Hire Alibag to Mumbai Cab with experienced drivers, comfortable vehicles, and affordable travel packages for a smooth return journey."
  },
  {
    "name": "Alibaug Car Rental Cost",
    "description": "Check Alibaug Car Rental Cost with transparent pricing, affordable packages, and premium chauffeur-driven vehicles."
  },
  {
    "name": "Alibaug Taxi Service",
    "description": "Book Alibaug Taxi Service with reliable drivers, clean AC vehicles, and flexible booking options for local and outstation travel."
  },
  {
    "name": "Dombivli to Alibaug Cab",
    "description": "Reserve Dombivli to Alibaug Cab with comfortable vehicles and experienced chauffeurs for hassle-free travel."
  },
  {
    "name": "Kharghar to Alibaug Taxi Fare",
    "description": "Check Kharghar to Alibaug Taxi Fare with affordable pricing and convenient chauffeur-driven transportation."
  },
  {
    "name": "Mumbai to Alibag Cabs",
    "description": "Book Mumbai to Alibag Cabs for comfortable beach travel with professional drivers and multiple vehicle options."
  },
  {
    "name": "Mumbai to Alibag Taxi",
    "description": "Choose Mumbai to Alibag Taxi for reliable intercity transportation with transparent fares and premium comfort."
  },
  {
    "name": "Mumbai to Alibaug Taxi",
    "description": "Hire Mumbai to Alibaug Taxi for convenient beach holidays with experienced drivers and well-maintained AC vehicles."
  },
  {
    "name": "Mumbai to Alibaug Taxi Service",
    "description": "Book Mumbai to Alibaug Taxi Service with affordable fares, flexible pickup, and one way or round trip options."
  },
  {
    "name": "Navi Mumbai to Alibaug Taxi Fare",
    "description": "Get Navi Mumbai to Alibaug Taxi Fare with competitive pricing and comfortable chauffeur-driven travel."
  },
  {
    "name": "Panvel to Alibaug Cab Price",
    "description": "Check Panvel to Alibaug Cab Price with budget-friendly packages and reliable transportation."
  },
  {
    "name": "Panvel to Alibaug Taxi Charges",
    "description": "Book Panvel to Alibaug Taxi Charges packages with transparent pricing and experienced chauffeurs."
  },
  {
    "name": "Taxi Fare from Mumbai to Alibaug",
    "description": "Compare Taxi Fare from Mumbai to Alibaug with affordable travel packages and quality cab services."
  },
  {
    "name": "Thane to Alibaug Taxi Fare",
    "description": "Reserve Thane to Alibaug Taxi Fare with reliable chauffeur-driven vehicles and competitive pricing."
  },
  {
    "name": "Taxi to Alibaug",
    "description": "Book Taxi to Alibaug with clean AC vehicles, professional drivers, and flexible travel schedules."
  },
  {
    "name": "Mumbai to Alibaug Cab",
    "description": "Choose Mumbai to Alibaug Cab for family trips, beach holidays, and convenient outstation travel with premium vehicles."
  },
  {
    "name": "Mumbai to Alibaug Taxi",
    "description": "Hire Mumbai to Alibaug Taxi with comfortable Sedan, Ertiga, Innova Crysta, SUV, and luxury cab options."
  },
  {
    "name": "Mumbai to Alibaug Cab Service",
    "description": "Book Mumbai to Alibaug Cab Service with experienced chauffeurs, doorstep pickup, and flexible travel plans."
  },
  {
    "name": "Mumbai to Alibaug Taxi Service",
    "description": "Reserve Mumbai to Alibaug Taxi Service for reliable long-distance transportation with premium comfort."
  },
  {
    "name": "Mumbai to Alibaug Car Rental",
    "description": "Choose Mumbai to Alibaug Car Rental with chauffeur-driven vehicles for beach holidays and sightseeing."
  },
  {
    "name": "Mumbai to Alibaug Cab Booking",
    "description": "Complete Mumbai to Alibaug Cab Booking online with instant confirmation and multiple vehicle choices."
  },
  {
    "name": "Mumbai to Alibaug Cabs",
    "description": "Book Mumbai to Alibaug Cabs with affordable fares and reliable drivers for smooth coastal travel."
  },
  {
    "name": "Mumbai to Alibaug Private Taxi",
    "description": "Reserve Mumbai to Alibaug Private Taxi for personalized travel with dedicated chauffeur service."
  },
  {
    "name": "Mumbai to Alibaug Car Hire",
    "description": "Hire Mumbai to Alibaug Car Hire with premium vehicles for family, business, and leisure travel."
  },
  {
    "name": "Mumbai to Alibaug Outstation Cab",
    "description": "Book Mumbai to Alibaug Outstation Cab with clean AC vehicles and experienced chauffeurs for comfortable travel."
  },
  {
    "name": "Innova Crysta Mumbai to Alibaug",
    "description": "Choose Innova Crysta Mumbai to Alibaug for luxury family travel with spacious seating and premium comfort."
  },
  {
    "name": "Innova Cab Mumbai to Alibaug",
    "description": "Reserve Innova Cab Mumbai to Alibaug for group travel with experienced drivers and spacious interiors."
  },
  {
    "name": "Ertiga Cab Mumbai to Alibaug",
    "description": "Book Ertiga Cab Mumbai to Alibaug for affordable 6 to 7 seater travel with comfortable seating."
  },
  {
    "name": "Swift Dzire Mumbai to Alibaug",
    "description": "Hire Swift Dzire Mumbai to Alibaug for economical and comfortable beach travel."
  },
  {
    "name": "Sedan Cab Mumbai to Alibaug",
    "description": "Choose Sedan Cab Mumbai to Alibaug for smooth highway journeys with professional chauffeurs."
  },
  {
    "name": "SUV Cab Mumbai to Alibaug",
    "description": "Book SUV Cab Mumbai to Alibaug with spacious seating and additional luggage capacity for family travel."
  },
  {
    "name": "Kia Carens Mumbai to Alibaug",
    "description": "Reserve Kia Carens Mumbai to Alibaug for premium comfort and spacious family travel."
  },
  {
    "name": "Tempo Traveller Mumbai to Alibaug",
    "description": "Hire Tempo Traveller Mumbai to Alibaug for group outings, family vacations, and corporate trips."
  },
  {
    "name": "Luxury Car Rental Mumbai to Alibaug",
    "description": "Book Luxury Car Rental Mumbai to Alibaug with premium chauffeur-driven vehicles for a luxurious travel experience."
  },
  {
    "name": "Family Cab Mumbai to Alibaug",
    "description": "Choose Family Cab Mumbai to Alibaug with spacious AC vehicles and experienced drivers for safe family holidays."
  },
  {
    "name": "Mumbai to Kashid Cab",
    "description": "Book Mumbai to Kashid Cab with reliable chauffeurs and comfortable vehicles for relaxing beach vacations."
  },
  {
    "name": "Mumbai to Murud Cab",
    "description": "Reserve Mumbai to Murud Cab for convenient coastal travel with affordable fares and premium chauffeur-driven service."
  }
],
"tableData": [
  ["Mumbai to Alibaug Cab", "Alibag to Mumbai Cab"],
  ["Alibaug Car Rental Cost", "Alibaug Taxi Service"],
  ["Dombivli to Alibaug Cab", "Kharghar to Alibaug Taxi Fare"],
  ["Mumbai to Alibag Cabs", "Mumbai to Alibag Taxi"],
  ["Mumbai to Alibaug Taxi", "Mumbai to Alibaug Taxi Service"],
  ["Navi Mumbai to Alibaug Taxi Fare", "Panvel to Alibaug Cab Price"],
  ["Panvel to Alibaug Taxi Charges", "Taxi Fare from Mumbai to Alibaug"],
  ["Thane to Alibaug Taxi Fare", "Taxi to Alibaug"],
  ["Mumbai to Alibaug Cab Service", "Mumbai to Alibaug Car Rental"],
  ["Mumbai to Alibaug Cab Booking", "Mumbai to Alibaug Cabs"],
  ["Mumbai to Alibaug Private Taxi", "Mumbai to Alibaug Car Hire"],
  ["Mumbai to Alibaug Outstation Cab", "Innova Crysta Mumbai to Alibaug"],
  ["Innova Cab Mumbai to Alibaug", "Ertiga Cab Mumbai to Alibaug"],
  ["Swift Dzire Mumbai to Alibaug", "Sedan Cab Mumbai to Alibaug"],
  ["SUV Cab Mumbai to Alibaug", "Kia Carens Mumbai to Alibaug"],
  ["Tempo Traveller Mumbai to Alibaug", "Luxury Car Rental Mumbai to Alibaug"],
  ["Family Cab Mumbai to Alibaug", "Mumbai to Kashid Cab"],
  ["Mumbai to Murud Cab", ""]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Alibaug Cab Service",
    WhyChoosedescription: "Shreesha Tours & Travels offers reliable Mumbai to Alibaug cab services with clean vehicles, courteous chauffeurs, and flexible travel options for beach holidays, family outings, and weekend trips."
  },
  {
    WhyChooseheading: "Perfect for Beach Getaways",
    WhyChoosedescription: "Enjoy a relaxing drive from Mumbai to Alibaug with a private cab, making your beach vacation, family picnic, couple's trip, or weekend escape convenient and enjoyable."
  },
  {
    WhyChooseheading: "Wide Choice of Vehicles",
    WhyChoosedescription: "Book Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium cars based on your group size, luggage, and travel preferences."
  },
  {
    WhyChooseheading: "One Way, Round Trip & Same-Day Return",
    WhyChoosedescription: "Choose one-way transfers, round-trip taxi services, or same-day return packages with flexible pickup and drop timings according to your travel schedule."
  },
  {
    WhyChooseheading: "Experienced Drivers for Coastal Routes",
    WhyChoosedescription: "Our professional chauffeurs are familiar with the Mumbai–Alibaug route and ensure a safe, smooth, and comfortable journey from start to finish."
  },
  {
    WhyChooseheading: "Customized Alibaug Sightseeing",
    WhyChoosedescription: "Enhance your trip by visiting popular attractions such as Alibaug Beach, Varsoli Beach, Nagaon Beach, Kihim Beach, Kolaba Fort, Murud-Janjira Fort, Kashid Beach, and other nearby destinations."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Fleet",
    WhyChoosedescription: "Our vehicles are regularly serviced, fully air-conditioned, and equipped with comfortable seating and ample luggage space for a pleasant road trip."
  },
  {
    WhyChooseheading: "Easy Booking with Shreesha Tours & Travels",
    WhyChoosedescription: "Reserve your Mumbai to Alibaug cab easily with transparent pricing, quick confirmation, and dedicated customer support for a hassle-free travel experience."
  }
]

};

const faqData = [
  {
    question: "Does Shreesha Tours & Travels provide Mumbai to Alibaug Cab Service?",
    answer: "Yes, we provide Mumbai to Alibaug cab services for one-way trips, round trips, beach holidays, sightseeing, and family travel."
  },
  {
    question: "Can I book a one-way cab from Mumbai to Alibaug?",
    answer: "Yes, one-way taxi services are available with pickup from any location in Mumbai."
  },
  {
    question: "Which vehicles are available for Mumbai to Alibaug travel?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Can I book a same-day return cab to Alibaug?",
    answer: "Yes, same-day return and round-trip taxi packages are available according to your travel requirements."
  },
  {
    question: "Can I include sightseeing during my Alibaug trip?",
    answer: "Yes, your itinerary can include Alibaug Beach, Nagaon Beach, Kihim Beach, Kolaba Fort, Murud-Janjira Fort, Kashid Beach, and other nearby attractions."
  },
  {
    question: "Is the cab suitable for family vacations and group travel?",
    answer: "Yes, our spacious and comfortable vehicles are ideal for families, friends, couples, and corporate groups."
  },
  {
    question: "Do you provide pickup from Mumbai Airport, hotels, and railway stations?",
    answer: "Yes, pickup is available from Mumbai Airport, railway stations, hotels, homes, offices, and any preferred location in Mumbai."
  },
  {
    question: "Are tolls and parking charges included in the fare?",
    answer: "Toll charges, parking fees, permits, and other applicable charges depend on the selected package and are clearly explained before booking."
  },
  {
    question: "Is Mumbai to Alibaug cab service available throughout the week?",
    answer: "Yes, Shreesha Tours & Travels provides daily cab services based on advance booking and vehicle availability."
  },
  {
    question: "How can I book a Mumbai to Alibaug Cab?",
    answer: "Share your pickup location, travel date, passenger details, preferred vehicle, and trip type to receive your fare quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Karan Shah",
    feedback: "We booked a Mumbai to Alibaug cab with Shreesha Tours & Travels for a weekend beach trip. The vehicle was spotless, the driver was professional, and the journey was relaxing.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Mehta",
    feedback: "Our family enjoyed a comfortable trip to Alibaug in an Innova Crysta. The booking process was quick, the cab was spacious, and the service was excellent throughout.",
    rating: 5
  }
];
























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Alibaug Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-alibaug-cab.webp",
  "description":
    "Book Mumbai to Alibaug Cab with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Mumbai, Navi Mumbai, Panvel, and nearby locations to Alibaug with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for beach holidays, family trips, weekend getaways, and business travel.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-alibaug-cab"
  }
};





    return (
        <div>
<Helmet>
  <title>Mumbai to Alibaug Cab | Beachside Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Alibaug Cab with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for affordable travel from Mumbai, Navi Mumbai, or Panvel to Alibaug with 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Alibaug Cab, Mumbai to Alibag Cabs, Mumbai to Alibag Taxi, Mumbai to Alibaug Taxi, Mumbai to Alibaug Taxi Service, Alibag to Mumbai Cab, Alibaug Car Rental Cost, Alibaug Taxi Service, Dombivli to Alibaug Cab, Kharghar to Alibaug Taxi Fare, Navi Mumbai to Alibaug Taxi Fare, Panvel to Alibaug Cab Price, Panvel to Alibaug Taxi Charges, Mumbai to Alibaug Cab Booking, Mumbai to Alibaug One Way Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/14.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitoalibaugcabs;